export const cards = [
    {
        title: 'Download Al-Saboor App', src: "/static/images/avatar/1.jpg", description: 'Find the best deals on our mobile app', alt: 'a'
    },
    { title: 'Help Center', src: "/static/images/avatar/1.jpg", description: 'Contact with our support team', alt: 'a' },
    { title: 'Manage Bookings', src: "/static/images/avatar/1.jpg", description: 'View and manage your bookings', alt: 'a' },
]

export const images = [
    {
        src: 'https://images.unsplash.com/photo-1502657877623-f66bf489d236',
        title: 'Night view',
        description: '4.21M views',
    },
    {
        src: 'https://images.unsplash.com/photo-1527549993586-dff825b37782',
        title: 'Lake view',
        description: '4.74M views',
    },
    {
        src: 'https://images.unsplash.com/photo-1532614338840-ab30cf10ed36',
        title: 'Mountain view',
        description: '3.98M views',
    },
];



export const TripOptions = [
    { label: 'One Way', value: 'One Way' },
    { label: 'Round Trip', value: 'Round Trip' },

];

export const TravelOptions = [

    { label: "Economy", value: "ECONOMY" }, { label: "Premium", value: "PREMIUM_ECONOMY" }, { label: "Business", value: "BUSINESS" }, { label: 'First Class', value: "FIRST" }
]

export const Airlines = [
    { label: "American Airlines", code: "AA" },
    { label: "Delta Air Lines", code: "DL" },
    { label: "United Airlines", code: "UA" },
    { label: "British Airways", code: "BA" },
    { label: "Emirates", code: "EK" },
    { label: "Qatar Airways", code: "QR" },
    { label: "Singapore Airlines", code: "SQ" },
    { label: "Lufthansa", code: "LH" },
    { label: "Air France", code: "AF" },
    { label: "KLM", code: "KL" }
];


export const Currencies = [
    { label: "Pakistani Rupee", code: "PKR" },
    { label: "US Dollar", code: "USD" },
    { label: "Euro", code: "EUR" },
    { label: "British Pound", code: "GBP" },
    { label: "Japanese Yen", code: "JPY" },
    { label: "Australian Dollar", code: "AUD" },
    { label: "Canadian Dollar", code: "CAD" },
    { label: "Swiss Franc", code: "CHF" },
    { label: "Chinese Yuan", code: "CNY" },
    { label: "Indian Rupee", code: "INR" },
    { label: "Emirati Dirham", code: "AED" }
];
